import Wix from './wix-sdk-polyfill';
import { debug } from './debug';

const getUserPrivacyStatus = cb =>
  Wix.currentMember(member => {
    if (!member) {
      return cb(undefined);
    }

    const { attributes } = member.data || member;

    debug.info(`privacyStatus: ${attributes.privacyStatus}`);
    cb(attributes.privacyStatus);
  });

export default getUserPrivacyStatus;
